import React, { Component, useState, useRef, useEffect, useMemo, useContext } from 'react';

import GoogleMapTracker from './GoogleMapTracker';

import {
  Button, Container, Row, Col,
} from 'reactstrap';


import { useTranslation } from 'react-i18next';
import '../99_untils/i18n';

import DutyCheckContext from "../Home/DutyCheckContext";
import { isFlutterAvailable, navigateToRoute } from '../99_untils/flutterCallback';
import './LiveMapping.css';

import NavTaxiSelectContext from "./NavTaxiSelectContext";
import NativeSelectDropdown from "./NativeSelectDropdown";


export default function LiveMapping( updateDuty ) {
  // console.log("LiveMapping constructor started ")
  const isMountedRef = useRef();

  const { t } = useTranslation();
  const { i18n } = useTranslation();
  let curLang = i18n.language;

  const dutyCheckContext = useContext(DutyCheckContext);
  const [dutyOnStatus, setDutyOnStatus] = useState(dutyCheckContext || true);
  const [isFlutterReady, setIsFlutterReady] = useState(false);

  const navTaxiSelectContext = useContext(NavTaxiSelectContext);
  const [navTaxiSelected, setNavTaxiSelected] = useState(navTaxiSelectContext);
  const navTaxiSelectFunc = (target) => {
  // const toggleTheme = () => {
    setNavTaxiSelected(target);
    // setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  // Helper function to handle book taxi button click with navigateToRoute
  const handleBookTaxiClick = () => {
    if (isFlutterReady) {
      navigateToRoute('/main/home/ride-hailing')
        .catch((error) => {
          console.error('Error navigating to ride-hailing:', error);
          // Fallback to HTTP link if navigation fails
          window.open('https://l.d-ash.com/p0cu2?tag=twiceweb', "_blank");
        });
    } else {
      // Fallback for non-Flutter environments (e.g., testing in browser)
      console.log('Flutter InAppWebView not ready, using fallback');
      window.open('https://l.d-ash.com/p0cu2?tag=twiceweb', "_blank");
    }
  };

  useEffect(() => {
    // Listen for Flutter InAppWebView platform ready event
    const handleFlutterReady = () => {
      console.log('Flutter InAppWebView platform is ready');
      setIsFlutterReady(true);
    };

    // Use { once: true } since platform ready event should only fire once
    window.addEventListener("flutterInAppWebViewPlatformReady", handleFlutterReady, { once: true });

    // Check if Flutter is already available (in case event fired before listener was added)
    if (isFlutterAvailable()) {
      setIsFlutterReady(true);
    }

    return () => {
      window.removeEventListener("flutterInAppWebViewPlatformReady", handleFlutterReady);
    };
  }, []);

  useEffect(() => {

    setDutyOnStatus(dutyCheckContext);
    // console.log("LiveMapping monitor updateDuty prop:", dutyCheckContext);
    
    return () => {

    };
  }, [dutyCheckContext]);


  useEffect(() => {

    isMountedRef.current = true;

    // console.log("LiveMapping isMountedRef");

    return () => {
      isMountedRef.current = false;
      // console.log("LiveMapping unmount")

    };
  }, []);


  return (
    <div className="">

      <div className='live-mapping-wrap'>
        <div>
          {dutyOnStatus ?
          <div>
            <NavTaxiSelectContext.Provider value={{navTaxiSelected, navTaxiSelectFunc}}>
              <GoogleMapTracker />
              <NativeSelectDropdown />
            </NavTaxiSelectContext.Provider>
          </div>
            :
            <div className='live-mapping-duty-off-wrap'>
              <div className='live-mapping-duty-off-mask'></div>
              <Container className='live-mapping-title-wrap'>
              <Row className=''>
                <Col
                  md={{
                    offset: 2,
                    size: 8
                  }}
                  xs={{
                    offset: 0,
                    size: 12
                  }}>
                  <h6 className='text-center color-text-white margin-bot-10'>
                   {t('liveMapTitleOffDuty')}
                    </h6>
                  <p className='text-center color-text-white'>
                    {t('liveMapContentOffDuty')}</p>
                </Col>
            </Row>
            </Container>
            </div>
          }

          <Container className='live-mapping-info-wrap'>
            <Row className='text-center'>
              <Col
                md={{
                  offset: 2,
                  size: 8
                }}
                xs={{
                  offset: 0,
                  size: 12
                }}>
                      <h5 
                      className={`${dutyOnStatus ? 
                        `text-uppercase margin-bot-10 color-text-pink home-title ${curLang === 'zh-HK' ? 'zh' : ''}`
                        : 
                        `text-uppercase margin-bot-10 color-text-pink home-title ${curLang === 'zh-HK' ? 'zh' : ''}`
                      }`
                      }
                      >
                        {t('liveMapTitle')}
                        </h5>
                      <p 
                      className={`${dutyOnStatus ? 
                        'live-mapping-intro-content color-text-pink margin-bot-15' : 
                        'live-mapping-intro-content color-text-pink margin-bot-15'}`}
                      >
                        {t('liveMapContent')}
                        </p>
                      <Button className={`live-mapping-info-button blink margin-bot-30 ${curLang === 'en-HK' ? 'en' : ''}`} size="lg" color="primary"
                        onClick={handleBookTaxiClick}>
                        {t('liveMapBtnBookTaxi')}</Button>
                {/* <Container>
                  <Row className='d-flex align-items-stretch'>
                    <Col className='p-3'
                      md={{
                        offset: 0,
                        size: 8
                      }}
                      xs={{
                        offset: 0,
                        size: 8
                      }}>
                      <h5 
                      className={`${dutyOnStatus ? 
                        `text-uppercase margin-bot-10 color-text-blue home-title ${curLang === 'zh-HK' ? 'zh' : ''}`
                        : 
                        `text-uppercase margin-bot-10 color-text-white home-title ${curLang === 'zh-HK' ? 'zh' : ''}`
                      }`
                      }
                      >
                        {t('liveMapTitle')}
                        </h5>
                      <p 
                      className={`${dutyOnStatus ? 
                        'live-mapping-intro-content bg-white color-text-blue margin-bot-0' : 
                        'live-mapping-intro-content color-text-white margin-bot-0'}`}
                      >
                        {t('liveMapContent')}
                        </p>
                    </Col>
                    <Col className='p-3 live-mapping-info-button-col'
                      md={{
                        offset: 0,
                        size: 4
                      }}
                      xs={{
                        offset: 0,
                        size: 4
                      }}>
                      <Button className={`live-mapping-info-button ${curLang === 'en-HK' ? 'en' : ''}`} size="lg" color="primary"
                        onClick={handleBookTaxiClick}>
                        {t('liveMapBtnBookTaxi')}</Button>
                    </Col>
                  </Row>
                </Container> */}
              </Col>
            </Row>
          </Container>
        </div>
      </div>

    </div>
  );
  // }
}

